var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('click', $event)},"mouseenter":_vm.handleMouseenter,"mouseleave":_vm.handleMouseleave}},[_c('DSIcon',{attrs:{"color":_vm.color,"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }